















import Vue from 'vue';

import { Loading, Icon, Tooltip } from '@/components/ds';
import Analytics from '@/helpers/analytics';
import VIEWS_NAMES from '@/router/viewsNames';
import accountsIframe from './helpers/accountsIframe';
import {
  installEqualWebLaunchButtonOffscreenStyle,
  showEqualWebDrawer,
} from './helpers/accessibility';
import { initVlibras } from './helpers/vlibras';

const equalWebSiteKey = 'aecf6ffe12fa1c1d26fe0ed3b1d39c4a';
const equalWebIntegrityKey =
  'sha512-3qLj5jbjMQnXk+FqEdVJjUnjJBGuBTRVOwaiT0ms6mQKQcrz4nulBxl2Hsr0/PpvEqdyJsMsU1NB+Mtfzw8hxA==';

export default Vue.extend({
  components: { Loading, Icon, Tooltip },
  data() {
    return { isLoading: false };
  },
  async created() {
    const isAuthenticated = Boolean(this.$cookies.get('admissions-auth-token'));
    this.isLoading = true;

    await new Promise((res: any) => {
      setTimeout(() => res(), 400);
    });

    const tokenD = accountsIframe.getTokenD();

    if (!isAuthenticated) {
      if (tokenD) {
        const email = accountsIframe.getEmailByPocket();
        try {
          await this.$store.dispatch('GET_USER', { email });

          const { user } = this.$store.getters;
          if (user) {
            await this.$store.dispatch('CREATE_AUTH_TOKEN');
          }
        } catch {
          this.navigateToSignUp();
          return;
        } finally {
          this.isLoading = false;
        }
      }
    }

    try {
      await this.$store.dispatch('PULL_CURRENT_ADMISSION');
      // antes do START_PIPELINE de propósito: é ele que produz a primeira navegação em
      // que os middlewares de fato avaliam a cidade.
      await this.$store.dispatch('RESTORE_SELECTED_CITY');
      await this.$store.dispatch('PULL_PIPELINE');
      await this.$store.dispatch('START_PIPELINE');
    } catch {
      // suppress error
    } finally {
      const { user } = this.$store.getters;
      if (user) {
        const { email, name } = user;
        Analytics.identify({ id: email, email, name });
      }

      this.isLoading = false;
    }
  },
  mounted() {
    this.insertEqualWebScript();
  },
  methods: {
    insertEqualWebScript(): void {
      if ((window as any).descomplicaEqualWebInjected) {
        return;
      }
      (window as any).descomplicaEqualWebInjected = true;

      (window as any).interdeal = {
        sitekey: equalWebSiteKey,
        Position: 'Right',
        Menulang: 'PT',
        domains: {
          js: 'https://cdn.equalweb.com/',
          acc: 'https://access.equalweb.com/',
        },
        btnStyle: {
          vPosition: [null, '20%'],
          color: {
            main: '#2E850F',
            second: '#000000',
          },
          scale: [0.5],
          icon: {
            type: 1,
            shape: 'circle',
            outline: false,
          },
        },
      };

      const scriptElement = document.createElement('script');
      scriptElement.src = 'https://cdn.equalweb.com/core/5.3.1/accessibility.js';
      scriptElement.defer = true;
      scriptElement.integrity = equalWebIntegrityKey;
      scriptElement.crossOrigin = 'anonymous';
      scriptElement.setAttribute('data-cfasync', 'true');
      scriptElement.onload = () => {
        installEqualWebLaunchButtonOffscreenStyle();
        initVlibras();
      };

      document.body.appendChild(scriptElement);
    },
    navigateToSignUp() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_UP });
    },

    navigateToSignIn() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_IN });
    },
    showAccessibilityDrawer() {
      Analytics.track('Open accessibility drawer', {
        origin: 'Botão Acessibilidade',
      });

      showEqualWebDrawer();
    },
  },
});
